import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { getSensores } from '../services/api';

const SensorList = () => {
  const { logout } = useContext(AuthContext);
  const [sensors, setSensors] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSensors = async () => {
      try {
        const token = localStorage.getItem('token');
        console.log("Token enviado:", token);
        const { data } = await getSensores(token);
        console.log("Sensores recibidos:", data);
        setSensors(data);
      } catch (error) {
        console.error('Error al obtener sensores:', error);
      }
    };
    fetchSensors();
  }, []);

  const handleSensorClick = (id) => {
    navigate(`/sensor/${id}`);
  };

  return (
    <div style={{ padding: '20px' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Mis Sensores</h2>
        <button className="small-button" onClick={logout}>Cerrar sesión</button>
      </header>

      <button onClick={() => navigate('/report')} style={{ margin: '15px 0', padding: '8px 12px' }}>
        Generar PDF
      </button>

      {sensors.length > 0 ? (
        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
          <thead>
            <tr style={{ backgroundColor: '#007bff', color: 'white' }}>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Nombre</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Tipo</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>DevEUI</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Imagen</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Temperatura</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>Humedad</th>
            </tr>
          </thead>
          <tbody>
            {sensors.map(sensor => (
              <tr key={sensor.id} onClick={() => handleSensorClick(sensor.id)} style={{ cursor: 'pointer' }}>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{sensor.nombre}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{sensor.tipo}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{sensor.deveui}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {sensor.imagen ? (
                    <img src={sensor.imagen} alt={sensor.nombre} style={{ maxWidth: '150px' }} />
                  ) : (
                    'No hay imagen'
                  )}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {sensor.last_reading !== null ? sensor.last_reading : "N/A"}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                  {sensor.last_secondary_reading !== null ? sensor.last_secondary_reading : "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No se encontraron sensores.</p>
      )}
    </div>
  );
};

export default SensorList;
